module.exports = __webpack_public_path__ + "img/cd6619cb-48c0-450c-a2ad-e69b204f5902.260ecc8b.png";